import axios from 'axios';

export const getCategories = async () => {
    try {
        const response = await axios.get('/api/categories');
        return response.data;
    } catch (error) {
        console.error('Error fetching categories:', error);
        throw error;
    }
}

export const getFeaturedCategories = async () => {
    try {
        const response = await axios.get('/api/categories/featured');
        return response.data;
    } catch (error) {
        console.error('Error fetching featured categories:', error);
        throw error;
    }
}